import { IJobInsight } from 'wisestep-api';

export default function formatJobInsights(insights: IJobInsight[]) {
  const insightArray: string[] = [];
  insights.forEach((insight) => {
    if (insight.insight) {
      insightArray.push(insight.insight);
    }
  });
  return insightArray;
}
